import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  background: rgba(0, 0, 0, 0.95);
  flex-direction: column;
  overflow-y: scroll;
  scroll-behavior: smooth;
  z-index: 999;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }
`

export const Header = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  padding: 6px 0;
  display: flex;
  align-items: center;
  background: #fff;
  z-index: 4;
`

export const Body = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 18px;
  padding-bottom: 100px;
`

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;

  & i {
    font-size: 22px;
    color: ${Color.gray600};
    cursor: pointer;
  }

  @media (min-width: 640px) {
    padding: 0 0;
    & i {
      font-size: 24px;
      right: 0px;
    }
  }

  @media (min-width: 1280px) {
    & i {
      font-size: 28px;
    }
  }
`

export const Select = styled.select`
  padding: 8px 8px;
  font-size: 16px;
  color: ${Color.gray100};
  background: ${Color.gray700};
  outline: none;
  border: none;
  border-radius: 4px;

  @media (min-width: 640px) {
    padding: 12px 16px;
  }

  & option {
    text-align: center;
  }
`

export const Input = styled.input`
  width: 100%;
  padding: 12px 10px;
  font-size: 18px;
  text-transform: capitalize;
  border: none;
  outline: none;

  @media (min-width: 640px) {
    padding: 12px 16px;
  }
`

export const Result = styled.div`
  width: 100%;
  height: auto;
  padding-top: 12px;
  padding-bottom: 24px;
  color: #f1f5f9;
  padding: 0 16px;
  padding-bottom: 40px;

  @media (min-width: 640px) {
    padding: 0 0;
    padding-bottom: 40px;
  }
`

export const Title = styled.h2`
  margin-bottom: 18px;
  color: ${Color.gray200};
  margin-left: 16px;

  @media (min-width: 640px) {
    margin-left: 0;
  }
`

export const Grid = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(6, minmax(100px, 1fr));
  grid-gap: 16px;

  @media (min-width: 640px) {
    padding: 6px 0px;
  }

  @media screen and (max-width: 1280px) {
    grid-template-columns: repeat(6, minmax(100px, 1fr));
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }

  @media screen and (max-width: 375px) {
    grid-template-columns: repeat(0, 1fr);
  }

  @media (min-width: 1280px) {
    grid-gap: 32px;
  }
`

export const Thumb = styled.div`
  position: relative;
  width: 100%;
  min-height: 100%;
  color: transparent;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  background: #f5f5f5;
  border: 2px solid #eee;
  overflow: hidden;

  @media (min-width: 768px) {
    min-width: 160px;
    height: 216px;
  }

  @media (min-width: 1280px) {
    width: 180px;
    height: 270px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(205.89deg, rgba(0, 0, 0, 0) 49.81%, rgba(0, 0, 0, 0.8) 97.75%);
    z-index: 1;
  }
`

export const Image = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
  animation: fadeIn 1s;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const Rating = styled.div`
  display: flex;
  position: absolute;
  left: 8px;
  bottom: 10px;
  padding: 2px 6px;
  font-weight: 700;
  background: ${({ bg }) => (bg ? bg : "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.24) 100%)")};
  color: ${({ color }) => color};
  border-radius: 3px;
  opacity: 0.9;
  z-index: 2;

  &i {
    margin-right: 4px;
  }
`

export const Info = styled.div`
  display: none;
  ${({ isTv }) => (isTv ? "display: block;" : "display: none;")}

  @media (min-width: 640px) {
    display: block;
    margin-top: 6px;
  }
`

export const Name = styled.h4`
  font-size: 16px;
  margin-bottom: 4px;
  color: ${Color.gray200};
  transition: color 0.3s ease-in-out;

  @media (min-width: 640px) {
    width: 100%;
    font-size: 16px;
    font-weight: medium;
    margin-bottom: 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`

export const Date = styled.p`
  font-size: 12px;
  color: ${Color.gray400};
  transition: color 0.3s ease-in-out;
  @media (min-width: 640px) {
    font-size: 14px;
  }
`
export const CardContainer = styled.div`
  text-decoration: none;

  &:hover ${Thumb} {
    border-color: ${Color.primary};
    filter: drop-shadow(0px 16px 24px rgba(56, 189, 248, 0.06)) drop-shadow(0px 2px 6px rgba(56, 189, 248, 0.04)) drop-shadow(0px 0px 1px rgba(56, 189, 248, 0.04));
  }

  &:hover ${Name} {
    color: ${Color.primary};
  }

  &:hover ${Date} {
    color: ${Color.gray200};
  }
`
